import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import { breakpoint } from '../../../vendorjs/breakpoint-helper.vendor';
export var searchFacetsBehavior = function searchFacetsBehavior() {
  Alpine.data('searchFacetsBehavior', function () {
    return {
      facetsIsOpen: false,
      init: function init() {
        this.facetsIsOpen = breakpoint.isDesktop;
        this.$watch('facetsIsOpen', this.facetsToggled);
      },
      facetsToggled: function facetsToggled(facetsIsOpen) {
        if (facetsIsOpen && !breakpoint.isDesktop) {
          document.body.classList.add('overflow-hidden');
        } else {
          document.body.classList.remove('overflow-hidden');
        }
      },
      bindFacets: {
        // eslint-disable-next-line func-names
        '@resize.window.stop.debounce': function resizeWindowStopDebounce() {
          this.facetsIsOpen = breakpoint.isDesktop;
        },
        // eslint-disable-next-line func-names
        '@click.outside': function clickOutside() {
          this.facetsIsOpen = breakpoint.isDesktop;
        }
      }
    };
  });
};